var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _path5, _g, _path6, _line6, _line7, _line8, _line9, _line10, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 60,
    viewBox: "0 0 218 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.54 54.7783V5C83.54 2.79086 85.3309 1 87.54 1H120.562C121.626 1 122.646 1.42373 123.396 2.1775L133.549 12.3734C134.296 13.1231 134.715 14.138 134.715 15.1959V54.7783C134.715 56.9874 132.924 58.7783 130.715 58.7783H87.54C85.3309 58.7783 83.54 56.9874 83.54 54.7783Z",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.883 36.3511L99.5199 33.1788C97.8462 31.6 97.8462 28.9383 99.5199 27.3595L102.883 24.1872",
    stroke: "#CCCCCC",
    strokeWidth: 2.58466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.165 24.187L117.528 27.3593C119.201 28.9381 119.201 31.5998 117.528 33.1786L114.165 36.3509",
    stroke: "#CCCCCC",
    strokeWidth: 2.58466,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.145 53.4768V12.0796C142.145 10.975 143.041 10.0796 144.145 10.0796H171.254C171.791 10.0796 172.306 10.2955 172.682 10.6788L181.192 19.3522C181.559 19.7261 181.765 20.229 181.765 20.7529V53.4768C181.765 54.5814 180.869 55.4768 179.765 55.4768H144.145C143.041 55.4768 142.145 54.5814 142.145 53.4768Z",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150.817,
    y1: 19.166,
    x2: 161.203,
    y2: 19.166,
    stroke: "#B8B9BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150.817,
    y1: 28.2451,
    x2: 170.712,
    y2: 28.2451,
    stroke: "#B8B9BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 150.817,
    y1: 33.541,
    x2: 170.712,
    y2: 33.541,
    stroke: "#B8B9BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 150.817,
    y1: 38.0811,
    x2: 170.712,
    y2: 38.0811,
    stroke: "#B8B9BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150.817,
    y1: 43.3779,
    x2: 170.712,
    y2: 43.3779,
    stroke: "#B8B9BA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.669 47.0483V18.5083C191.669 17.956 192.117 17.5083 192.669 17.5083H209.945C210.226 17.5083 210.495 17.6268 210.684 17.8346L216.17 23.8524C216.338 24.0366 216.431 24.2768 216.431 24.5261V47.0483C216.431 47.6005 215.983 48.0483 215.431 48.0483H192.669C192.117 48.0483 191.669 47.6005 191.669 47.0483Z",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3829_9173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.217 35.804C210.753 35.309 209.803 35.0228 208.458 35.0228C207.738 35.0228 206.906 35.0943 206 35.2629C205.446 34.7167 204.942 34.1222 204.494 33.4864C204.147 33.0041 203.843 32.4935 203.565 31.9906C204.095 30.3317 204.353 28.9786 204.353 28.0038C204.353 26.9114 203.958 25.7729 202.824 25.7729C202.474 25.7729 202.127 25.9847 201.941 26.2964C201.43 27.2153 201.66 29.232 202.541 31.2227C202.205 32.2382 201.834 33.242 201.43 34.2323C201.047 35.1408 200.628 36.0331 200.172 36.9072C197.622 37.9437 195.97 39.1508 195.817 40.1005C195.748 40.4578 195.866 40.7847 196.116 41.0474C196.202 41.1189 196.529 41.4022 197.083 41.4022C198.775 41.4022 200.557 38.6073 201.466 36.9199C202.16 36.6852 202.857 36.4705 203.551 36.2563C204.285 36.0538 205.028 35.8877 205.777 35.7584C207.564 37.3948 209.139 37.6526 209.93 37.6526C210.905 37.6526 211.252 37.2492 211.37 36.9199C211.554 36.4935 211.416 36.024 211.207 35.7814L211.22 35.8069L211.217 35.804ZM210.313 36.493C210.244 36.8479 209.895 37.0851 209.407 37.0851C209.27 37.0851 209.152 37.0596 209.012 37.039C208.123 36.8243 207.292 36.373 206.462 35.6604C207.105 35.5523 207.757 35.4977 208.409 35.4972C208.892 35.4972 209.311 35.5202 209.591 35.5918C209.913 35.6609 210.423 35.8775 210.309 36.4955H210.321L210.313 36.493ZM205.397 35.3776C204.752 35.5094 204.11 35.6601 203.473 35.8295C202.919 35.98 202.37 36.1485 201.827 36.3347C202.109 35.7763 202.372 35.2084 202.615 34.6322C202.896 33.9662 203.126 33.2796 203.358 32.641C203.586 33.0419 203.84 33.4452 204.096 33.8049C204.514 34.3739 204.951 34.9155 205.39 35.3874V35.3747L205.397 35.3776ZM202.357 26.5664C202.398 26.4828 202.461 26.4119 202.539 26.3616C202.617 26.3112 202.708 26.2832 202.801 26.2807C203.289 26.2807 203.38 26.8472 203.38 27.3015C203.38 28.0646 203.148 29.2236 202.752 30.5459C202.058 28.7032 202.012 27.1614 202.359 26.5664H202.357ZM199.807 37.6085C198.625 39.5967 197.489 40.8298 196.793 40.8298C196.657 40.8298 196.54 40.7813 196.448 40.7122C196.308 40.5691 196.239 40.4034 196.285 40.2142C196.425 39.5022 197.747 38.5068 199.81 37.608L199.807 37.6085Z",
    fill: "#CCCCCC"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6678 53.4768V12.0796C35.6678 10.975 36.5633 10.0796 37.6678 10.0796H65.4128C65.9427 10.0796 66.4509 10.2898 66.8259 10.6642L75.5257 19.3496C75.9015 19.7247 76.1126 20.234 76.1126 20.765V53.4768C76.1126 54.5814 75.2172 55.4768 74.1126 55.4768H37.6678C36.5633 55.4768 35.6678 54.5814 35.6678 53.4768Z",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 42.7709,
    y1: 23.7861,
    x2: 42.7709,
    y2: 47.5483,
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 67.8616,
    y1: 48.1313,
    x2: 43.097,
    y2: 48.1314,
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 48.3423,
    y1: 44.9238,
    x2: 48.3423,
    y2: 25.7824,
    stroke: "#CCCCCC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 56.392,
    y1: 44.9238,
    x2: 56.392,
    y2: 33.4174,
    stroke: "#CCCCCC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 62.834,
    y1: 44.9238,
    x2: 62.834,
    y2: 38.7618,
    stroke: "#CCCCCC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8001 41.6319L13.8002 41.6318L14.9936 40.7788L14.9938 40.7786C15.128 40.6828 15.2368 40.5406 15.2994 40.3675C15.362 40.1942 15.3734 40.0028 15.3312 39.821C15.3312 39.821 15.3312 39.821 15.3312 39.821L14.8441 37.7335L13.8001 41.6319ZM13.8001 41.6319C13.672 41.7236 13.5255 41.7699 13.3788 41.7699C13.2322 41.7699 13.0857 41.7236 12.9576 41.632C12.9576 41.632 12.9576 41.6319 12.9576 41.6319L11.7656 40.779L13.8001 41.6319ZM14.9257 35.2474L14.5634 35.5853C14.4134 35.4245 14.2177 35.3413 14.0217 35.3413H12.7385C12.5425 35.3413 12.3468 35.4245 12.1968 35.5853C12.0457 35.7473 11.9553 35.9741 11.9553 36.2172V37.3927C11.9553 37.5074 11.9422 37.6218 11.9161 37.7335L11.429 39.8212C11.3867 40.0029 11.398 40.1943 11.4604 40.3676C11.5228 40.5407 11.6314 40.6829 11.7655 40.7789L14.9257 35.2474ZM14.9257 35.2474L14.5634 35.5853C14.7145 35.7473 14.8049 35.9741 14.8049 36.2172M14.9257 35.2474L14.8049 36.2172M14.8049 36.2172V37.3927M14.8049 36.2172V37.3927M14.8049 37.3927C14.8049 37.5074 14.8181 37.6218 14.8441 37.7335L14.8049 37.3927ZM12.2131 37.7283L12.2131 37.7285L11.852 39.2754C11.7139 39.867 11.9462 40.4835 12.4404 40.8367L12.5075 40.8847C13.0295 41.2578 13.7309 41.2576 14.2527 40.8843L14.3192 40.8366C14.813 40.4833 15.0451 39.8671 14.9071 39.2758L14.5462 37.7302C14.5462 37.7299 14.5461 37.7297 14.5461 37.7294C14.5297 37.6577 14.5214 37.5839 14.5217 37.5096H14.5217V37.5078V36.8588C14.5217 36.2283 14.0106 35.7172 13.3801 35.7172C12.7496 35.7172 12.2385 36.2283 12.2385 36.8588V37.5077C12.2385 37.5078 12.2385 37.5078 12.2385 37.5078C12.2385 37.5823 12.2299 37.6564 12.2131 37.7283Z",
    stroke: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 47.8737V18.5083C1 17.956 1.44772 17.5083 2 17.5083H21.1684C21.4377 17.5083 21.6957 17.617 21.8839 17.8097L27.9538 24.0265C28.1362 24.2133 28.2383 24.464 28.2383 24.7251V47.8737C28.2383 48.4259 27.7906 48.8737 27.2383 48.8737H2C1.44772 48.8737 1 48.4259 1 47.8737Z",
    stroke: "#999999",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3915 21.1394H14.0328C14.5851 21.1394 15.0328 20.6917 15.0328 20.1394V19.333C15.0328 18.7807 14.5851 18.333 14.0328 18.333H12.0709C11.5186 18.333 11.0709 18.7807 11.0709 19.333V20.1394C11.0709 20.6917 10.6231 21.1394 10.0709 21.1394H9.42957C8.87728 21.1394 8.42957 21.5871 8.42957 22.1394V22.9458C8.42957 23.498 8.87728 23.9458 9.42956 23.9458H10.0709C10.6231 23.9458 11.0709 24.3935 11.0709 24.9458V25.7521C11.0709 26.3044 10.6231 26.7521 10.0709 26.7521H9.42957C8.87728 26.7521 8.42957 27.1998 8.42957 27.7521V28.5585C8.42957 29.1108 8.87728 29.5585 9.42956 29.5585H10.0709C10.6231 29.5585 11.0709 30.0062 11.0709 30.5585V31.3649C11.0709 31.9172 11.5186 32.3649 12.0709 32.3649H14.0328C14.5851 32.3649 15.0328 31.9172 15.0328 31.3649V30.5585C15.0328 30.0062 14.5851 29.5585 14.0328 29.5585H13.3915C12.8392 29.5585 12.3915 29.1108 12.3915 28.5585V27.7521C12.3915 27.1998 12.8392 26.7521 13.3915 26.7521H14.0328C14.5851 26.7521 15.0328 26.3044 15.0328 25.7521V24.9458C15.0328 24.3935 14.5851 23.9458 14.0328 23.9458H13.3915C12.8392 23.9458 12.3915 23.498 12.3915 22.9458V22.1394C12.3915 21.5871 12.8392 21.1394 13.3915 21.1394Z",
    fill: "#CCCCCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3829_9173"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.797,
    y: 25.7622,
    width: 15.6827,
    height: 15.6827,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.801cbe6312c83b3e8dd49c3aea0198f2.svg";
export { ForwardRef as ReactComponent };